import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import { Box, Typography } from '@mui/material';

import { caloTheme } from '../../assets/themes/calo';

const { palette } = caloTheme;

const TaskTag = ({ children }: { children: string }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      mt: 1,
      px: 1,
      py: 0.25,
      borderRadius: '8px',
      backgroundColor: palette.primary100,
      color: palette.primary800
    }}
  >
    <AutorenewOutlinedIcon sx={{ fontSize: 16 }} />
    <Typography component="span" sx={{ fontSize: 14, lineHeight: '20px', fontWeight: 700 }}>
      {children}
    </Typography>
  </Box>
);

export default TaskTag;
